import { render, staticRenderFns } from "./AlternativeRelationshipsDialog.vue?vue&type=template&id=5391ada4"
import script from "./AlternativeRelationshipsDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativeRelationshipsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports